module.exports = __webpack_public_path__ + "img/aParty_110523_I.bbf97f21.jpg";